import i18n from 'i18n-js';

import { localTime } from '@helpers';

export const formatHeaderDateText = (selectedTime: string, mString?: string, mEndString?: string): string => {
  let m = localTime(mString);
  let mEnd = localTime(mEndString);
  if (!m || !mEnd) {
    m = localTime();
    mEnd = localTime();
  }

  switch (selectedTime) {
    case 'year':
      m = m.startOf('year');
      return `${m.format('YYYY')}`;
    case 'month':
      return `${i18n.t(m.format('MMM'))} ${m.format('YYYY')}`;
    case 'week': {
      const iso = m.isoWeek();
      const isThisWeek = iso === localTime().isoWeek();
      if (isThisWeek) {
        return `${i18n.t('This Week')}`;
      }
      const isLastWeek = iso === localTime().subtract(1, 'week').isoWeek();
      if (isLastWeek) {
        return `${i18n.t('Last Week')}`;
      }
      return `${i18n.t('Week')} ${iso}`;
    }
    case 'day': {
      const isToday = m.isSame(localTime().startOf('day'), 'd');
      if (isToday) {
        return `${i18n.t('Today')}`;
      }
      const isYesterday = m.isSame(localTime().subtract(1, 'days').startOf('day'), 'd');
      if (isYesterday) {
        return `${i18n.t('Yesterday')}`;
      }
      return `${i18n.t(m.format('ddd'))} ${m.format('DD')} ${i18n.t(m.format('MMM'))} ${i18n.t(m.format('YYYY'))}`;
    }
    case 'eightWeeks': {
      const startWeek = m.clone().startOf('isoWeek');
      const lastWeek = startWeek.clone().add(7, 'isoWeek');
      return `${i18n.t('Week')} ${startWeek.isoWeek()}-${lastWeek.isoWeek()} ${lastWeek.isoWeekYear()}`;
    }
    default:
      return '';
  }
};
